import * as React from 'react'
import { SVGProps } from 'react'

const FILUSD = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect x='0.5' y='0.5' width='47' height='47' rx='23.5' fill='white' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M26.28 21.12L25.56 24.96L32.4 25.92L31.92 27.72L25.2 26.76C24.72 28.32 24.48 30 23.88 31.44C23.28 33.12 22.68 34.8 21.96 36.36C21 38.4 19.32 39.84 17.04 40.2C15.72 40.44 14.28 40.32 13.2 39.48C12.84 39.24 12.48 38.76 12.48 38.4C12.48 37.92 12.72 37.32 13.08 37.08C13.32 36.96 13.92 37.08 14.28 37.2C14.64 37.56 15 38.04 15.24 38.52C15.96 39.48 16.92 39.6 17.88 38.88C18.96 37.92 19.56 36.6 19.92 35.28C20.64 32.4 21.36 29.64 21.96 26.76V26.28L15.6 25.32L15.84 23.52L22.44 24.48L23.28 20.76L16.44 19.68L16.68 17.76L23.76 18.72C24 18 24.12 17.4 24.36 16.8C24.96 14.64 25.56 12.48 27 10.56C28.44 8.64 30.12 7.44 32.64 7.56C33.72 7.56 34.8 7.92 35.52 8.76C35.64 8.88 35.88 9.12 35.88 9.36C35.88 9.84 35.88 10.44 35.52 10.8C35.04 11.16 34.44 11.04 33.96 10.56C33.6 10.2 33.36 9.84 33 9.48C32.28 8.52 31.2 8.4 30.36 9.24C29.76 9.84 29.16 10.68 28.8 11.52C27.96 14.04 27.36 16.68 26.52 19.32L33.12 20.28L32.64 22.08L26.28 21.12Z'
      fill='#0090FF'
    />
    <rect x='0.5' y='0.5' width='47' height='47' rx='23.5' stroke='#D1D3E5' />
  </svg>
)

export default FILUSD
